export class TooltipManager {
  private static instance: TooltipManager;

  private currentTooltip: string | null = null;

  private listeners: Map<string, () => void> = new Map();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): TooltipManager {
    if (!TooltipManager.instance) {
      TooltipManager.instance = new TooltipManager();
    }
    return TooltipManager.instance;
  }

  register(id: string, closeCallback: () => void) {
    this.listeners.set(id, closeCallback);
  }

  unregister(id: string) {
    this.listeners.delete(id);
  }

  openTooltip(id: string) {
    if (this.currentTooltip && this.currentTooltip !== id) {
      const closeCallback = this.listeners.get(this.currentTooltip);
      if (closeCallback) {
        closeCallback();
      }
    }
    this.currentTooltip = id;
  }

  closeTooltip(id: string) {
    if (this.currentTooltip === id) {
      this.currentTooltip = null;
    }
  }
}
